import { createStyles } from '../../../styles/helpers'

export default createStyles({
  errorContainer: {
    marginTop: [0, '!important']
  }
})
